module.exports = __webpack_public_path__ + "media/media/cases/rosneft/rosneft2-fb1ace8a321ed417eeadab47b184cf0d.jpg";